import { ModelBase } from 'store/model-base';
import { CountryStatus } from 'international/constants';

export class InternationalRate extends ModelBase {
    public static storeName: string = 'international';

    public id: string;
    public status: CountryStatus;
    public displayName: string;
    public searchTags: string[];
    public rates: RoamingRates;
    public greetingImage: string;
    public gtpAvailable: boolean;
    public gtpPrice: string;
}
